(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fast-flow-choose"]) return;
  try {
    
$(document).ready(function(){
  $('.sixChoice').on('click', function(){
    $('.pchoices').removeClass('active');
    $('.pchoices').addClass('inactive');
    ga('send', 'event', 'System Shopping', 'Fast Flow Action', 'To Polish Pick' );
    $(this).addClass('active');
        $('.toggle').hide();
    $('.six-color').show();

    $('.pchoices').prop('ariaSelected', false);
    $(this).prop('ariaSelected', true);
  });
  $('.oneChoice').on('click', function(){
   $('.pchoices').removeClass('active');
 $('.pchoices').addClass('inactive');
    ga('send', 'event', 'System Shopping', 'Fast Flow Action', 'To Polish Pick' );
    $(this).addClass('active');
    $('.toggle').hide();
    $('.one-color').show();
        $('.pchoices').prop('ariaSelected', false);
    $(this).prop('ariaSelected', true);
  });
  

  $('.extraChoice').on('click', function(){
   $('.pchoices').removeClass('active');
     $('.pchoices').addClass('inactive');
      ga('send', 'event', 'System Shopping', 'Fast Flow Action', 'To Polish Pick' );
    $(this).addClass('active');
    $('.toggle').hide();
    $('.extra').show();
    $('.pchoices').prop('ariaSelected', false);
    $(this).prop('ariaSelected', true);
  });

  $('.llChoice').on('click', function(){
    $('.fchoices').removeClass('active');
     $('.fchoices').addClass('inactive');
    ga('send', 'event', 'System Shopping', 'Fast Flow Action', 'To Polish Pick' );
    $(this).addClass('active');
        $('.ftoggle').hide();
    $('.long-lasting-cta').show();

    $('.fchoices').prop('ariaSelected', false);
    $(this).prop('ariaSelected', true);
  });

  $('.qdChoice').on('click', function(){
    $('.fchoices').removeClass('active');
         $('.fchoices').addClass('inactive');
    ga('send', 'event', 'System Shopping', 'Fast Flow Action', 'To Polish Pick' );
    $(this).addClass('active');
        $('.ftoggle').hide();
    $('.quick-dry-cta').show();
    $('.fchoices').prop('ariaSelected', false);
    $(this).prop('ariaSelected', true);
  });

  $('.mmChoice').on('click', function(){
    $('.fchoices').removeClass('active');
         $('.fchoices').addClass('inactive');
    ga('send', 'event', 'System Shopping', 'Fast Flow Action', 'To Polish Pick' );
    $(this).addClass('active');
        $('.ftoggle').hide();
    $('.mix-match-cta').show();
    $('.fchoices').prop('ariaSelected', false);
    $(this).prop('ariaSelected', true);
  });  
  $('.fbacked').on('click', function(){
    $('.formula-pick').hide();
    $('.polish-pick').show();
  });
  
  $('.six-cta').on('click', function(){
    $('.formula-6').show();
    $('.polish-pick').hide();
  });
  $('.one-cta').on('click', function(){
    $('.polish-pick').hide();
    $('.formula-1').show();
    $('.polish-pick').hide();
  });

$('.dis').on('click', function(){
  $('.error').show();
});

});


  } catch(e) { console.error(e); }
})();
})();
